/** @module csi/widget/_svg/_3DBrowserMixin **/
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/threeD/paths",
	"csi/action",
	"csi/def/Action",
	"csi/reflection",
	"csi/service/rightPaneService",
	"csi/state/rootStore",
	"csi/xml",
	"dijit/Menu",
	"dijit/CheckedMenuItem",
	"csi/_base/underscore",
], function(declare, lang, modelPaths, csiAction, Action, reflection, {close3dViewer}, {rightPaneStore}, xml, Menu, CheckedMenuItem, _) {

	return declare(null, {
		"class": "csi-button-toggle",

		/**
		 * Query to determine if there are 3D material documents available to browse
		 */
		postCreate: function() {
			var view = this.getView();
			this[this.storeName] = modelPaths.getNodesStore(view.getViewNode(), view.cacheView);
			this._deferred = this[this.storeName] && this[this.storeName].query();

			this.inherited(arguments);
		},

		/**
		 * Only enable if there are any 3D Models available for the current canvas
		 * @param {Shape[]} shapes
		 * @param {Object} shapeAttrs
		 * @param {Object} textAttrs
		 * @return {boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			return this[this.storeName] && !!this[this.storeName].getTotal();
		},

		/** 
		 * Function to add documents to the drop down menu
		 */
		threeDBrowserDropDownMenu: async function() {
			var self = this;
			var documents = await self[self.storeName].query();
			var menu = new Menu({
				"class": "svgSelect",
				style: "display: none;"
			});
			_.each(documents, function(doc, i) {
				var item = new CheckedMenuItem({
					label: doc.$Name,
					iconClass: "csi-checked-menu-item-check",
					onClick: function(e) {
						self.onThreeDBrowserDropDownClick(e, this);
					},
					value: i,
					checked: false
				});
				menu.addChild(item);
			});

			return menu;
		},

		/**
		 * Function to set the selected document to the 3D viewer
		 * @param {Event} e
		 * @param {Object} item
		 */
		onThreeDBrowserDropDownClick: function(e, item) {
			var self = this;
			var documents = self[self.storeName].query();
			var document = documents[item.get("value")];
			var view = self.getView();

			var popupAction = lang.mixin(new Action(), {
				classController: "csi/threeD/ViewerController",
				m_id: self.viewId,
			});

			popupAction.resolve();

			csiAction.invoke(view, null, popupAction, {
				m_urlNode: document ? document.$URL : null,

				onCreatePopupParams: function(params) {
					params[self.storeName] = self[self.storeName];
				},

				onUploadSnapshot: function(snapshotData) {
					this.widget.canvasWidgetNode.add3DSnapshots(snapshotData);
					this.widget.canvasWidgetNode.getPlugin("canvasrightmenu").refreshItemImagePane();
					rightPaneStore.closeDialog();
					close3dViewer(true);
				},

				onStart: function() {
					// override controller to use standard MultiFilePublish for data sheet images
					this.m_action.dependencyPaths = [xml.path(reflection.ATTR_LATEST_REVISION)];
					this.m_urlParent = view.getViewNode().__Parent__;
					this.m_idAttrParent = reflection.ATTR_IMAGES;
				},

				onEnd: function() {
					item.set("checked", false);
				}
			});
		}
	});
});